import { createRoute } from "@tanstack/react-router";
import { workspaceRoute } from "../shell/routes";
import { DashboardPage } from "./DashboardPage";

/** Dashboard (WP-014): counts, today's tasks, link tiles. The landing screen of a workspace. */
export const dashboardRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: "dashboard",
  component: function Dashboard() {
    const { workspaceId } = dashboardRoute.useParams();
    return <DashboardPage key={workspaceId} workspaceId={workspaceId} />;
  },
});
